import { render, staticRenderFns } from "./ServiceRequestClientCard.vue?vue&type=template&id=70309aab&scoped=true"
import script from "./ServiceRequestClientCard.vue?vue&type=script&lang=js"
export * from "./ServiceRequestClientCard.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestClientCard.vue?vue&type=style&index=0&id=70309aab&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70309aab",
  null
  
)

export default component.exports